<template>
	<div class="page">
		<div class="main flex">
			<div class="left">
				<div class="item f-a pointer " v-for="(item, index) in category_list" 
				:class="{ active: tabs_index == index }" @click="tabsChange(index)"
				>{{ language=='cn'?item.title:item.title_en }}</div>
			</div>
			
			<router-view :index="tabs_index"></router-view>
		</div>
	</div>
</template>

<script>
import { category_list } from '@/data/data.js';
import index from "./index.vue"
export default {
	data() {
		return {
			category_list,
			tabs_index: 0,
			icon: require('@/assets/image/精油水薰衣草/1.jpg')
		};
	},

	computed: {
		getCategory() {
			console.log(this.category_list[this.tabs_index]);
			return this.category_list[this.tabs_index];
		},
		language(){
			return this.$store.state.language
		}
	},
	methods:{
		tabsChange(index){
			this.tabs_index = index
			
			if(this.$route.path.indexOf('/category/detail')>=0){
				this.$router.replace('/category')
			}
		}
	}
};
</script>

<style lang="less" scoped>
.main {
	width: 100%;
	max-width: 100%;
	margin: 0 auto;
	font-size: 16px;
}

.left {
	border-right: 1px solid #eaeaea;
	// background-color: rgb(247, 251, 255);
	.item {
		width: 200px;
		height: 56px;
		text-indent: 20px;
		background-color: #fff;
	}
	.active {
		background-color: #ecf5ff;
	}
	.active::before{
		content: '';
		width: 3px;
		height: 100%;
		background-color: red;
	}
	.item:hover {
		background-color: #ecf5ff;
	}
}

</style>
